export const decodeEntities = (() => {
  // Thanks, https://stackoverflow.com/questions/5796718/html-entity-decode
  // this prevents any overhead from creating the object each time
  const element = document.createElement('div');

  const decodeHTMLEntities = (string) => {
    let result = 'ERROR';
    if (typeof string === 'string') {
      // strip script/html tags
      const sanitizedString = string
        .replace(/<script[^>]*>([\S\s]*?)<\/script>/gmi, '')
        .replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gmi, '');
      element.innerHTML = sanitizedString;
      result = element.textContent;
      element.textContent = '';
    }
    return result;
  }

  return decodeHTMLEntities;
})();


export const slugify = (string) => {
  // Thanks, https://gist.github.com/mathewbyrne/1280286
  return decodeEntities(string.toString()).toLowerCase()
    .replace(/\s+/g, '-')           // Replace spaces with -
    .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
    .replace(/\-\-+/g, '-')         // Replace multiple - with single -
    .replace(/^-+/, '')             // Trim - from start of text
    .replace(/-+$/, '');            // Trim - from end of text
};
